// extracted by mini-css-extract-plugin
module.exports = {"container":"Success_container__3cipr","mainMessage":"Success_mainMessage__124i6","message":"Success_message__35Fyc"};